module.exports = __webpack_public_path__ + "img/angular.43bc2898.svg";